import React from 'react'
import { DocumentTranslation } from 'api/Documents/Types/Document'
import {
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import styled from 'styled-components'
import { isEmpty } from 'utils/is-empty'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 5rem;
`

interface OuterProps {
  translations: DocumentTranslation[]
}

export const DocumentTranslationFormUI: React.FC<OuterProps> = ({ translations }) => {
  if (isEmpty(translations)) {
    return <Container>No translations found.</Container>
  }
  return (
    <FormBaseContainer>
      <form>
        {translations.map((field) => (
          <FormBaseFieldBlock key={field.translationField}>
            <FormBaseRow>
              <FormBaseFieldLabel>{field.translationField}</FormBaseFieldLabel>
              <FormBaseFieldGroup>
                <input type='text' name={field.translationField} value={field.value} disabled />
              </FormBaseFieldGroup>
            </FormBaseRow>
          </FormBaseFieldBlock>
        ))}
      </form>
    </FormBaseContainer>
  )
}
